const runScriptOnReady = require('public/js/lib/run-script-on-ready');

/* global rp$ */
function productQuantity() {
	const $increaseBtn = rp$(".quantity-btn.plus");
	const $decreaseBtn = rp$(".quantity-btn.minus");
	const $quantityInput = rp$(".quantity-display");

	function updateQuantity(quantity, skuStripped, $currentIncreaseBtn, $currentDecreaseBtn) {
		// Set the quantity for both mobile and desktop element
		rp$(`.quantity-display[data-sku-stripped="${skuStripped}"]`).each(function (index, element) {
			const $quantity = rp$(this);
			$quantity.val(quantity);
		});

		// Update button states based on quantity
		$currentIncreaseBtn.prop('disabled', quantity >= 10000);
		$currentDecreaseBtn.prop('disabled', quantity <= 1);
	}

	// Validate input and reset to 1 if invalid
	function validateQuantity(value, returnEmpty = false) {
		// If returnEmpty is true and value is falsy, return an empty string
		if (returnEmpty && !value) {
			return "";
		}

		// Ensure the value is within bounds: between 1 and 10000
		return Math.max(1, Math.min(10000, value || 1));
	}

	$quantityInput.on("change", function (e) {
		const $quantity = rp$(this);
		const skuStripped = $quantity.data('sku-stripped');

		const $currentIncreaseBtn = $quantity.siblings(`.quantity-btn.plus`);
		const $currentDecreaseBtn = $quantity.siblings(`.quantity-btn.minus`);

		// Validate and update quantity based on user input
		const quantity = validateQuantity(parseInt($quantity.val()));
		updateQuantity(quantity, skuStripped, $currentIncreaseBtn, $currentDecreaseBtn);
	});

	$quantityInput.on("input", function (e) {
		const $quantity = rp$(this);
		const skuStripped = $quantity.data('sku-stripped');

		const $currentIncreaseBtn = $quantity.siblings(`.quantity-btn.plus`);
		const $currentDecreaseBtn = $quantity.siblings(`.quantity-btn.minus`);

		// Validate and update quantity based on user input
		const quantity = validateQuantity(parseInt($quantity.val()), true);
		updateQuantity(quantity, skuStripped, $currentIncreaseBtn, $currentDecreaseBtn);
	});

	$quantityInput.on("keydown", function(e) {
		// Prevent Enter key from triggering form submission
		if (e.key === "Enter" || e.keyCode === 13) {
			e.preventDefault();
		}
	});

	$increaseBtn.on("click", function () {
		const $currentIncreaseBtn = rp$(this);
		const $currentDecreaseBtn = $currentIncreaseBtn.siblings(`.quantity-btn.minus`);

		// Find the quantity element with the same class on the same level
		const $quantity = $currentIncreaseBtn.siblings(`.quantity-display`);
		const skuStripped = $quantity.data('sku-stripped');
		
		// Increase quantity and validate it
		const quantity = validateQuantity(parseInt($quantity.val()) + 1);
		updateQuantity(quantity, skuStripped, $currentIncreaseBtn, $currentDecreaseBtn);
	});

	$decreaseBtn.on("click", function () {
		const $currentDecreaseBtn = rp$(this);
		const $currentIncreaseBtn = $currentDecreaseBtn.siblings(`.quantity-btn.plus`);

		// Find the quantity element with the same class on the same level
		const $quantity = $currentDecreaseBtn.siblings(`.quantity-display`);
		const skuStripped = $quantity.data('sku-stripped');

		// Decrease quantity and validate it
		const quantity = validateQuantity(parseInt($quantity.val()) - 1);
		updateQuantity(quantity, skuStripped, $currentIncreaseBtn, $currentDecreaseBtn);
	});
}

rp$.fn.product_quantity = productQuantity;

runScriptOnReady('product_quantity', productQuantity);
